// module factories are used so entry inlining is disabled
// run startup
return __webpack_require__.x();
